export default "__VITE_PUBLIC_ASSET__5ab85075__"